import Vue from 'vue';
import Vuex from 'vuex';
import appModule from './modules/app';
import loadingModule from './modules/loading';
import menuModule from './modules/menu';
import userModule from './modules/user';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    app: appModule,
    menu: menuModule,
    loading: loadingModule,
    user: userModule,
  },
});
